<template>
    <div>
        <!-- ========== HEADER ========== -->
        <header id="header" class="u-header">
            <div class="u-header__section">
                <TopBar/>

                <div id="logoAndNav" class="container">
                    <!-- Nav -->
                    <nav class="js-mega-menu navbar navbar-expand-md u-header__navbar u-header__navbar--no-space">
                        <Logo/>

                    </nav>
                    <!-- End Nav -->
                </div>
            </div>
        </header>
        <!-- ========== END HEADER ========== -->

        <!-- ========== MAIN ========== -->
        <main id="content" role="main">
            <div class="bg-primary">
                <div class="container space-1">
                    <div class="d-sm-flex justify-content-sm-between align-items-sm-center">
                        <div class="mb-3 mb-sm-0">
                            <!-- Breadcrumb -->
                            <ol class="breadcrumb breadcrumb-white breadcrumb-no-gutter mb-0">
                                <li class="breadcrumb-item">
                                    <router-link class="breadcrumb-link" :to="{'name': 'home'}">Accueil</router-link>
                                </li>
                                <li class="breadcrumb-item active" aria-current="page">Post</li>
                            </ol>
                            <!-- End Breadcrumb -->
                        </div>
                    </div>
                </div>
            </div>

            <FlexLoader v-if="$apollo.queries.post.loading" class="container space-2"/>
            <!-- Article Description Section -->
            <div v-else class="container space-2">
                <div class="w-lg-60 mx-lg-auto">
                    <div class="mb-4">
                        <h1 class="h2 font-weight-medium"> {{ post.subject }}</h1>
                    </div>

                    <!-- Author -->
                    <div class="border-top border-bottom py-4 mb-5">
                        <div class="row align-items-md-center">
                            <div class="col-md-7 mb-5 mb-md-0">
                                <div class="media align-items-center">
                                    <div class="u-avatar">
                                        <img class="img-fluid rounded-circle"
                                             src="../../public/assets/img/100x100/anonymous_user.png"
                                             alt="Image Description">
                                    </div>
                                    <div class="media-body font-size-1 ml-3">
                                        <span class="h6 font-weight-medium">
                                            <router-link :to="{name: 'viewProfile', params: {username: post.author.username}}">
                                                {{ post.author.profile.displayName }}
                                            </router-link>
                                        </span>
                                        <span class="d-block text-muted">{{ postCreatedDisplay }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Author -->
                </div>

                <div class="w-lg-60 mx-lg-auto">
                    <p> {{ post.message }}</p>

                    <hr class="mt-5"/>

                    <TagsView :tags="post_tags" :isFilterable="false"/>

                    <hr class="mt-2 mb-3"/>

                    <a v-for="(url, idx) in post.imagesUrls" :key="'post_image_' + idx" :href="url" target="_blank">
                        <img :src="url" alt="Post image" width="200" class="mx-2 my-2 rounded"/>
                    </a>

                    <hr class="mt-5 mb-3"/>

                    <a v-for="(url, idx) in post.documentsUrls" :key="'post_doc_' + idx" :href="url" target="_blank"
                       class="mx-2">
                        Document_joint_{{idx + 1}}.pdf
                    </a>

                    <hr class="mt-2 mb-2"/>

                    <div v-if="commentsCount !== 0" class="border-top mt-5 pt-2">
                        <div class="mt-5 mb-4">
                            <h3 class="h5"> {{ commentsCount }} commentaire<span v-if="commentsCount>1">s</span></h3>
                        </div>

                        <PostCommentView v-for="comment in post.commentSet.edges" :key="comment.node.id"
                                         :comment="comment.node"/>

                    </div>

                    <div class="mt-7 mb-5">
                        <h3 class="h5">Faire un commentaire</h3>
                    </div>

                    <PostCommentForm :postId="post_id"/>
                </div>
            </div>
            <!-- End Article Description Section -->
        </main>
        <!-- ========== END MAIN ========== -->

        <FooterA/>

        <GoToTop/>
    </div>
</template>

<script>
    import GoToTop from "../components/GoToTop";
    import TopBar from "../components/TopBar";
    import FooterA from "../components/FooterA";
    import Logo from "../components/Logo";
    import {GET_POST} from "../settings/graphql";
    import PostCommentView from "../components/PostCommentView";
    import PostCommentForm from "../components/PostCommentForm";
    import TagsView from "../components/TagsView";
    import {moment} from "../xlib";
    import FlexLoader from "../components/FlexLoader";

    export default {
        name: "PostView",
        components: {FlexLoader, TagsView, PostCommentForm, PostCommentView, Logo, FooterA, TopBar, GoToTop},
        data() {
            return {
                post_id: this.$route.params.post_id,
                post: {created: null},
                post_tags: [],
            }
        },
        computed: {
            postCreatedDisplay: function () {
                return moment(this.post.created).format('LLL');
            },
            commentsCount: function () {
                return this.post.commentSet.edges.length;
            }
        },
        methods: {
            setPostTags(tags) {
                this.$data.post_tags = tags;
            },
        },
        apollo: {
            post: {
                query: GET_POST,
                variables() {
                    return {
                        id: this.post_id,
                    }
                },
                update(data){
                    const post = data.post;
                    // console.log(`Post retrieved: ${JSON.stringify(post)}`);
                    this.setPostTags(post.tagSet);
                    return post;
                }
            }
        }
    }
</script>

<style scoped>

</style>